import { INote, NotesService } from '../../services';
import * as angular from 'angular';

class CrmDashboardController implements ng.IComponentController {
    private sortTypeContacts: string;
    private sortType: string;

    private currentNote: any;
    private notes: INote[];
    private notesService: any;

    constructor(NotesService: NotesService, private $state: ng.ui.IStateService) {
        'ngInject';
        // console.log('AccountsItemController');

        this.notesService = NotesService;

        this.sortType = 'name';
        this.sortTypeContacts = 'lastName';
    }

    updateNote(item, action) {
        switch (action) {
            case 'edit':
                this.updateNoteModal(item);
                break;
            case 'delete':
                this.deleteNote(item);
                break;
        }
    }

    updateNoteModal(item) {
        this.currentNote = item;
        (<any>$('#noteModal')).modal('show');
    }

    submitNote(item) {
        var newNote = item;
        newNote.date = new Date(Date.now());

        if (newNote.id == null) {
            this.notesService.post(newNote).then(result => {
                this.notes.push(result);
            });
        } else {
            this.notesService.put(newNote.id, newNote);
        }

        (<any>$('#noteModal')).modal('hide');
    }

    deleteNote(item) {
        this.notes = this.notes.filter(note => note.id !== item.id);

        this.notesService.delete(item.id);
    }
}

export const crmDashboardComponent: ng.IComponentOptions = {
    bindings: { 
        accounts: '<',
        contacts: '<',
        summary: '<',
        notes: '<'
    },
    controller: CrmDashboardController,
    template: require('./crm.dashboard.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/crm/crm.dashboard.component.ts